import React, { PureComponent } from 'react';

import { PropTypes as MobxPropTypes } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';

import NotificationItemAreaCommunity from './NotificationItemAreaCommunity';
import NotificationItemInteraction from './NotificationItemInteraction';
import NotificationItemPlaceholder from './NotificationItemPlaceholder';

import { EVENT_TYPE } from '../../constants';
import NotificationEvents from '../../events';

import './NotificationList.scss';

export default class NotificationList extends PureComponent {
  static propTypes = {
    items: MobxPropTypes.observableArray
  };

  components = {
    [EVENT_TYPE.AREA_COMMUNITY_EVENT]: NotificationItemAreaCommunity,
    [EVENT_TYPE.COMMENT]: NotificationItemInteraction,
    [EVENT_TYPE.LIKE]: NotificationItemInteraction,
    [EVENT_TYPE.REPLY]: NotificationItemInteraction
  };

  render() {
    const { items } = this.props;

    return (
      <div className="notification__list">
        {items.length ? (
          this.renderItems(items)
        ) : (
          <NotificationItemPlaceholder />
        )}
      </div>
    );
  }

  onViewNotification = () => {
    NotificationEvents.sendClick({ label: 'ViewMessage' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.NOTIFICATIONS_HORIZONTAL_MENU,
        label: EVENTS_LABELS.HORIZONTAL_MENU.VIEW_MESSAGE,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });
  };

  renderItems(items) {
    return items.map((item) => {
      const Component = this.components[item.event];

      return (
        <div key={item.id} onClick={this.onViewNotification}>
          <Component {...item} key={item.id} />
        </div>
      );
    });
  }
}
